export const Footer = () => (
  <footer
    data-testid="site-footer"
    className="border-t border-slate-200 mt-20 bg-white"
  >
    <div className="max-w-6xl mx-auto px-6 lg:px-10 py-10 grid gap-6 sm:grid-cols-2">
      <div>
        <p className="font-display font-bold text-slate-900 text-lg">
          Mattoo RoleFinder
        </p>
        <p className="text-sm text-slate-500 mt-1 max-w-md">
          A free, private career assessment built by
          <a
            href="https://www.mattooconsulting.com"
            target="_blank"
            rel="noreferrer"
            className="text-amber-700 hover:underline ml-1"
          >
            Mattoo Consulting
          </a>
          &nbsp;to help you pick the right next role in the Australian IT
          market.
        </p>
      </div>
      <div className="sm:text-right text-sm text-slate-500">
        <p>© {new Date().getFullYear()} Mattoo Consulting. All rights reserved.</p>
        <p className="mt-1">Crafted with clarity for career switchers.</p>
      </div>
    </div>
  </footer>
);

export default Footer;
